import api from '../../api'
import { MerchantStatusData } from '../../../domain/invoicing/rainforest'

export const getAdminMerchantStatus = async (tenantId: number): Promise<MerchantStatusData> => {
  return (await api.get('/web/admin/rainforest-merchants/merchant-status', { params: { tenantId } })).data
}

export const resetPaymentsApplication = async (tenantId: number): Promise<void> => {
  await api.post('/web/admin/rainforest-merchants/reset-application', { tenantId })
}
